import { ArenaTournament } from 'modules/arena/tournaments/types';
import { TOURNAMENT_STATUS_LABELS } from 'modules/arena/tournaments/content';
import { Badge } from 'shared/components/ui/Badge';
import { cn } from 'shared/utils/cn';

interface TournamentRowProps {
  tournament: ArenaTournament;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const STATUS_TONE = {
  rascunho: 'neutral',
  publicado: 'success',
  encerrado: 'accent',
} as const;

export function TournamentRow({ tournament, isSelected, onSelect }: TournamentRowProps) {
  const totalCapacity = tournament.categories.reduce((sum, category) => sum + category.capacity, 0);
  const totalRegistered = tournament.categories.reduce(
    (sum, category) => sum + category.registrations.filter((r) => r.status !== 'cancelada').length,
    0
  );
  const totalWaitlist = tournament.categories.reduce((sum, category) => sum + category.waitlist.length, 0);

  return (
    <button
      type="button"
      onClick={() => onSelect(tournament.id)}
      className={cn(
        'flex w-full flex-col gap-1 rounded-xl border p-4 text-left transition-colors',
        isSelected ? 'border-primary bg-accent-soft/30' : 'border-border/40 hover:border-primary'
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-ink">{tournament.name}</span>
        <Badge tone={STATUS_TONE[tournament.status]}>{TOURNAMENT_STATUS_LABELS[tournament.status]}</Badge>
      </div>

      <p className="text-sm text-ink-secondary">
        {tournament.sport} · {tournament.court}
      </p>
      <p className="text-xs text-ink-secondary">{tournament.dateLabel}</p>

      <div className="mt-1 flex items-center justify-between text-sm">
        <span className="font-medium text-ink">
          {totalRegistered}/{totalCapacity} duplas
        </span>
        {totalWaitlist > 0 && <span className="text-warning">{totalWaitlist} na lista de espera</span>}
      </div>
    </button>
  );
}
